import React, { useState } from "react";
import { Link } from "react-router-dom";
import { Card, Row, Col, Spinner } from "react-bootstrap";
import ApexCharts from "components/elements/charts/ApexCharts";
import quizLogo from "assets/images/quizLogo.png";
import Questions from "./Questions";
import { useNavigate } from "react-router-dom";

const QuizTimeOut = ({
  score,
  quiz,
  selectedAnswers,
  correctAnswers,
  userScore,
  totalScore,
  status,
  retryQuiz,
  loading,
}) => {
  const [isReviewMode, setIsReviewMode] = useState(false);
  const navigate = useNavigate();

  const QuizResultChartSeries = [score];
  const chartColor = score >= 80.0 ? "#38a169" : "#e53e3e"; 
  const backgroundColor = score >= 80.0 ? "#d1f5ea" : "#fcdcdc";

  const QuizResultChartOptions = {
    colors: [chartColor],
    plotOptions: {
      radialBar: {
        hollow: {
          margin: -2,
          size: "50%",
          background: backgroundColor,
        },
        dataLabels: {
          name: { show: true, fontSize: "18px", fontWeight: 600, offsetY: 7 },
          value: { show: false },
        },
      },
    },
    labels: [`${score}%`],
  };

  const handleClick = () => {
    navigate("/assessment-review");
  };

  const handleReviewQuestions = () => {
    setIsReviewMode(true);
  };

  const handleBackToQuiz = () => {
    setIsReviewMode(false);
  };

  const handleRetryQuiz = () => {
    retryQuiz("retry");
  };

  if (loading) {
    return (
      <div className="d-flex justify-content-center align-items-center w-100 h-100 course-container ">
        <Spinner />
      </div>
    );
  }

  if (isReviewMode) {
    return (
      <>
        <Row>
          <Col lg={12} md={12} sm={12}>
            <div
              className="justify-content-between align-items-center d-flex p-2 px-15"
              style={{ backgroundColor: "#f1eef0" }}
            >
              <div className="text-center">
                <h3 className="text-dark mb-0">
                  You have successfully completed the quiz
                </h3>
              </div>
              <div className="d-flex justify-content-center">
                <div className="resultChart">
                  <ApexCharts
                    options={QuizResultChartOptions}
                    series={QuizResultChartSeries}
                    type="radialBar"
                    height={150}
                  />
                </div>
              </div>
              <div>
                <img
                  src={quizLogo}
                  alt="Quiz completion logo"
                  width={150}
                  height={150}
                />
              </div>
            </div>
          </Col>
        </Row>

        <div>
          <div className="d-flex justify-content-start my-4">
            <button className="btn btn-secondary" onClick={handleBackToQuiz}>
              Back
            </button>

          </div>

          <Card className="mb-4">
            <Card.Body className="card-body-scroll">
              <h4 className="mb-3">Review Questions</h4>
              <div className="mt-5">
                <Questions
                  questions={quiz.questions}
                  selectedAnswers={selectedAnswers}
                  isReview={true}
                  correctAnswers={correctAnswers}
                />
              </div>
            </Card.Body>
          </Card>
        </div>
      </>
    );
  }

  if (status) {
    return (
      <Card>
        <Card.Body className="p-10 text-center">
          <div className="mb-4">
            <h2>Congratulations! You have successfully completed the quiz</h2>
          </div>
          <div className="d-flex justify-content-center">
            <div className="resultChart">
              <ApexCharts
                options={QuizResultChartOptions}
                series={QuizResultChartSeries}
                type="radialBar"
                height={150}
              />
            </div>
          </div>
          <div className="mt-3">
            <span>
              Your Score:{" "}
              <span className="text-dark">
                {score}% ({userScore} out of {totalScore})
              </span>
            </span>
            <br />
            <span className="mt-2 d-block">
              Passing Score: <span className="text-dark">80%</span>
            </span>
          </div>
          <div className="mt-5 d-flex justify-content-center">
            <Link to="#" className="btn btn-primary me-3" onClick={handleReviewQuestions}>
              Review Answers
            </Link>
            <button className="btn btn-primary me-3" onClick={handleRetryQuiz}>
            Retry Quiz
          </button>
             <button
            className="btn btn-outline-primary me-3"
            style={{
              color: "var(--bs-primary)",
              borderColor: "var(--bs-primary)",
              borderWidth: "2px",
            }}
            onMouseEnter={(e) => {
              e.target.style.backgroundColor = "white";
              e.target.style.color = "var(--bs-primary)";
              e.target.style.borderColor = "var(--bs-primary)";
            }}
            onMouseLeave={(e) => {
              e.target.style.backgroundColor = "white";
              e.target.style.color = "var(--bs-primary)";
              e.target.style.borderColor = "var(--bs-primary)";
            }}
            onClick={handleClick}
          >
            Go to Assesment Review
          </button>
          </div>
        </Card.Body>
      </Card>
    );
  }

  return (
    <Card>
      <Card.Body className="p-10 text-center">
        <div className="mb-4">
          <h2>You have failed the quiz! Review and Try again.</h2>
        </div>
        <div className="d-flex justify-content-center">
          <div className="resultChart">
            <ApexCharts
              options={QuizResultChartOptions}
              series={QuizResultChartSeries}
              type="radialBar"
              height={150}
            />
          </div>
        </div>
        <div className="mt-3">
          <span>
            Your Score:{" "}
            <span className="text-dark">
              {score}% ({userScore} out of {totalScore})
            </span>
          </span>
          <br />
          <span className="mt-2 d-block">
            Passing Score: <span className="text-dark">80%</span>
          </span>
        </div>
        <div className="mt-5 d-flex justify-content-center">
          <button className="btn btn-primary me-3" onClick={handleRetryQuiz}>
            Retry Quiz
          </button>
          <button
            className="btn btn-outline-primary me-3"
            style={{
              color: "var(--bs-primary)",
              borderColor: "var(--bs-primary)",
              borderWidth: "2px",
            }}
            onMouseEnter={(e) => {
              e.target.style.backgroundColor = "white";
              e.target.style.color = "var(--bs-primary)";
              e.target.style.borderColor = "var(--bs-primary)";
            }}
            onMouseLeave={(e) => {
              e.target.style.backgroundColor = "white";
              e.target.style.color = "var(--bs-primary)";
              e.target.style.borderColor = "var(--bs-primary)";
            }}
            onClick={handleClick}
          >
            Go to Assesment Review
          </button>
        </div>
      </Card.Body>
    </Card>
  );
};

  export default QuizTimeOut;
